import axios from '@/configs/axios'
import { ILoginResponse } from '@/models/session'
import { PaginationDTO } from '@/models/table'
import { IUser, IUserDTO, UserRole } from '@/models/user'
import * as ls from '@/services/localStorage'
import { Router } from 'vue-router'

const apiUrl = process.env.VUE_APP_API_URL
const loginRedirect = '/dashboard'
const logoutRedirect = '/login'
const accessTokenKey = process.env.VUE_APP_LS_ACCESS_TOKEN_KEY
const userLoggedKey = 'user'

export const login = (email: string, password: string) => {
  return axios.post<ILoginResponse>(`${apiUrl}/users/login`, { email, password })
}

export const loginAd = (username: string, password: string, email?: string | null) => {
  return axios.post<ILoginResponse>(`${apiUrl}/users/login-ad`, { username, password, email })
}

export const auth = (router: Router, accessToken?: string, user?: IUser) => {
  ls.set(accessTokenKey, accessToken)
  ls.set(userLoggedKey, user)

  if (user && !verifyAccessUser(user)) {
    return false
  }

  if (user?.hasOwnProperty('isPasswordAlteredOnce') && !user.isPasswordAlteredOnce) {
    router.push('/change-password')
  } else {
    router.push(loginRedirect)
  }

  return true
}

export const logout = async (router: Router) => {
  ls.remove(accessTokenKey)
  ls.remove(userLoggedKey)
  await router.push(logoutRedirect)
}

export const getUsers = (
  pagination: PaginationDTO<IUser>,
  searchString?: string,
  sortOrder?: string,
) => {
  const params = {
    page: pagination.page,
    pageSize: pagination.pageSize,
    searchString: searchString || undefined,
    sortOrder: sortOrder,
  }

  return axios.get<PaginationDTO<IUser>>(`${apiUrl}/users`, { params })
}

export const saveUser = (dto: IUserDTO) => {
  return axios.post(`${apiUrl}/users`, dto)
}

export const updateUser = (dto: IUserDTO) => {
  return axios.put(`${apiUrl}/users`, dto)
}

export const updateSelf = (dto: IUserDTO) => {
  return axios.put(`${apiUrl}/users/self`, dto)
}

export const deleteUser = (email: string) => {
  return axios.delete(`${apiUrl}/users/${email}`)
}

export const unlockUser = (user: IUserDTO) => {
  const newData = {
    email: user.email.toLowerCase(),
    newPassword: user.password,
  }
  return axios.post(`${apiUrl}/users/reset-user-blocked`, newData)
}

export const getUserName = (): string | null => {
  const user = ls.get(userLoggedKey)
  return user?.name || null
}

export const recoverPassword = (email: string, oldPassword: string, newPassword: string) => {
  return axios.post(`${apiUrl}/users/change-password`, { email, oldPassword, newPassword })
}

export const getByUsernameLdap = (username: string) =>
  axios.get<IUser>(`${apiUrl}/users/ldap/by-username/${username}`)

export const getByEmailNormal = (email: string) =>
  axios.get<IUser>(`${apiUrl}/users/normal/by-email/${email}`)

const verifyAccessUser = (user: IUser) => {
  switch (user.userRole) {
    case UserRole.Sap:
      return false
    case UserRole.Erector:
      return false
    default:
      return true
  }
}
